import { Field, FieldAttributes } from 'formik'

import { RadioInputLabel, RadioInputWrapper, StyledRadioInput } from './styles'

interface RadioFieldProps extends FieldAttributes<any> {
  label: string
  inputId?: string
}

const RadioButton = ({
  field,
  label,
  value,
  form,
  inputId,
  ...props
}: RadioFieldProps) => {
  const idInput = inputId || field.name
  return (
    <RadioInputWrapper>
      <StyledRadioInput
        type="radio"
        id={idInput}
        name={field.name}
        checked={form.values[field.name] === value}
        {...field}
        {...props}
        value={value}
      />
      <RadioInputLabel htmlFor={idInput}>{label}</RadioInputLabel>
    </RadioInputWrapper>
  )
}

function RadioField({ ...props }: RadioFieldProps) {
  return <Field component={RadioButton} {...props} />
}

export default RadioField
